module.exports = __webpack_public_path__ + "kudos_58.svg?785a900283bfa7b41cc69b1590567969";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_58.svg
// module id = 159
// module chunks = 0